const ReferenceFormatter = (contentItem) => {
  const responseText = contentItem.text.value;
  const annotations = contentItem.text.annotations || [];

  const cleanMessage = (text) => {
    if (!text) return "";
    return text
      .replace(/【\d+:\d+】/g, "")
      .replace(/【\d+:\d+†[^】]+】/g, "")
      .replace(/sandbox:[^\s]+/g, "")
      .replace(/\uE100.*?\uE101/g, "")
      .replace(/[\uE000-\uF8FF]/g, "")
      .replace(/cite.*?file\d+/g, "")
      .replace(/,+/g, ",")
      .replace(/^,|,$/g, "")
      .replace(/\s+$/g, "")
      .trim();
  };

  let cleanedText = cleanMessage(responseText);

  const fileIdToIndex = new Map();
  const fileIdToFilename = new Map();
  const fileIdToCount = new Map();
  let currentIndex = 1;

  annotations.forEach((annotation) => {
    if (annotation.file_id && annotation.filename) {
      const fileId = annotation.file_id;
      const filename = annotation.filename.split('/').pop();

      if (!fileIdToIndex.has(fileId)) {
        fileIdToIndex.set(fileId, currentIndex++);
        fileIdToFilename.set(fileId, filename);
        fileIdToCount.set(fileId, 1)
      } else {
        fileIdToCount.set(fileId, fileIdToCount.get(fileId) + 1)
      }

      const mainIndex = fileIdToIndex.get(fileId)
      const subIndex = fileIdToCount.get(fileId)
      const fileRefId = `${mainIndex}.${subIndex}`
      
      annotation.fileRefId = fileRefId
    }
  });

  cleanedText = cleanedText.replace(/\[(file-[a-zA-Z0-9+/=:-]+)\]/g, (match, fullKey) => {
    const [fileId, sourceIndex] = fullKey.split('+');
    if (!fileIdToIndex.has(fileId)) return match;

    const source = annotations.find((annotation) => annotation.index === sourceIndex);
    if (!source || !source.fileRefId) return match;

    const filename = fileIdToFilename.get(fileId);
    const fileRefId = source.fileRefId;

    return `[${fileRefId}](#ref-${fileRefId} "${filename}")`;
  });

 let referencesMarkdown = "";
  if (annotations.length > 0) {
    referencesMarkdown = "\n\n# References\n";

    const uniqueRefs = new Map();
    annotations.forEach((annotation) => {
      if (annotation.fileRefId && !uniqueRefs.has(annotation.fileRefId)) {
        uniqueRefs.set(annotation.fileRefId, {
          fileRefId: annotation.fileRefId,
          filename: annotation.filename?.split('/').pop(),
          pages: annotation.pageReference,
        });
      }
    });

    const sorted = Array.from(uniqueRefs.values()).sort((a, b) => {
      const [aMain, aSub] = a.fileRefId.split('.').map(Number);
      const [bMain, bSub] = b.fileRefId.split('.').map(Number);
      return aMain === bMain ? aSub - bSub : aMain - bMain;
    });

    sorted.forEach(({ fileRefId, filename, pages }) => {
      referencesMarkdown += `[${fileRefId}](#ref-${fileRefId}) ${filename} Pages: ${pages}\n\n`;
    });
  }

  return cleanedText + referencesMarkdown;
};

export default ReferenceFormatter;